<template>
  <footer class="app-footer">
    <div class="footer-help">
      <!-- QA-217: acceso a Ayuda oculto a pedido de SENAPRED; el div se conserva
           porque la grilla del footer usa esta columna para alinear los logos -->
      <!--
      <router-link
        v-if="$store.getters.getPermissions"
        :to="'/ayuda'"
      >
        ¿Necesitas ayuda?
      </router-link>
      -->
    </div>

    <div
      class="footer-logos"
      aria-label="Instituciones responsables"
    >
      <img
        class="footer-logo footer-logo--senapred"
        alt="SENAPRED, Ministerio del Interior, Gobierno de Chile"
        src="../assets/img/logo_gobierno.png"
      />

      <div class="footer-logo-divider" aria-hidden="true"></div>

      <img
        class="footer-logo footer-logo--citiaps"
        alt="CITIAPS, Innovación en TI para Aplicaciones Sociales"
        src="../assets/img/imago-citiaps-blanco.svg"
      />
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterFixes',
  props: {
    msg: String
  },
  methods: {
    toggleFooter() {
      
    }
  },
  mounted() {
    
  },
  beforeDestroyed() {

  },
  watch: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.app-footer {
  min-height: 148px;
  padding: 24px 5%;

  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 48px;

  background: var(--color-navy);
  color: var(--color-white);
}

.footer-help {
  display: flex;
  align-items: center;
}

.footer-help a {
  color: var(--color-white);
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
}

.footer-help a:hover {
  text-decoration: underline;
}

.footer-logos {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
}

.footer-logo {
  display: block;
  height: auto;
  object-fit: contain;
}

.footer-logo--senapred {
  width: auto;
  height: 96px;
}

.footer-logo--citiaps {
  width: clamp(164px, 11vw, 190px);
  max-height: 76px;
}

.footer-logo-divider {
  width: 1px;
  height: 64px;
  flex: 0 0 1px;
  background: rgba(255, 255, 255, 0.35);
}

@media only screen and (max-width: 640px) {
  .app-footer {
    min-height: auto;
    padding: 26px 18px;

    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 18px;
    text-align: center;
  }

  .footer-logos {
    justify-content: center;
    gap: 18px;
  }

  .footer-logo--senapred {
    height: 80px;
  }

  .footer-logo--citiaps {
    width: 150px;
    max-height: 62px;
  }

  .footer-logo-divider {
    height: 52px;
  }
}
</style>
